import { put, takeEvery } from "redux-saga/effects";
import apiCall from "./../../Services/api";
import {
  GET_SEO_QUICK_FIX_SCORE,
  GET_SEO_DETAIL_BY_TYPE,
  GET_SEO_REPORT,
  UPDATE_SEO_DETAIL_BY_TYPE,
  GET_GSC_DETAILS,
} from "../ActionTypes/seo";
import { SEO } from "../../Services/apiUrls";
import { setPageLoaderVisibility } from "../Actions";
import { ToastNotifyError } from "../../Components/Toast";
import { getStoreId, parseToJson } from "../../Utils/common";

function* getSEOQuickFixScore(actions: any) {
  const storeId = getStoreId();
  try {
    yield put(setPageLoaderVisibility(true));
    const response = yield apiCall({
      method: "GET",
      url: SEO.fetchSeoQuickFixScore(storeId),
    });
    if (response && response?.data?.status) {
      actions?.callback?.(response?.data?.status, response?.data?.seo_score_data);
      yield put(setPageLoaderVisibility(false));
    } else {
      actions?.callback?.(response?.data?.status, null);
      yield put(setPageLoaderVisibility(false));
    }
  } catch (err) {
    yield put(setPageLoaderVisibility(false));
    err?.data?.message && ToastNotifyError(err.data.message);
  }
}

function* getSeoDetailsByType(actions: any) {
  const storeId = getStoreId();
  try {
    yield put(setPageLoaderVisibility(true));
    const response = yield apiCall({
      method: "GET",
      url: `${SEO.getSeoDetailsByType}?type=${actions.data.type}&type_id=${actions.data.typeId}&store_id=${storeId}`,
    });
    if (response && response?.data?.status) {
      // const parsedResponse = parseToJson(response.data.data);
      actions?.callback?.(response?.data?.status, response?.data?.type_details);
      yield put(setPageLoaderVisibility(false));
    } else {
      actions?.callback?.(response?.data?.status, null);
      yield put(setPageLoaderVisibility(false));
    }
  } catch (err) {
    yield put(setPageLoaderVisibility(false));
    err?.data?.message && ToastNotifyError(err.data.message);
  }
}

function* updateSeoDetailsByType(actions: any): any {
  try {
    const response = yield apiCall({
      method: "PATCH",
      url: SEO.upsertSeoDetailsByType,
      data: actions.data,
    });
    if (response && response.data.status) {
      actions?.callback?.(response.data.status, response.data);
      yield put(setPageLoaderVisibility(false));
    }
  } catch (err: any) {
    err?.data?.message && ToastNotifyError(err.data.message);
    actions?.callback?.(false, null);
  }
}

function* getSeoReport(actions: any) {
  try {
    yield put(setPageLoaderVisibility(true));
    const response = yield apiCall({
      method: "POST",
      url: SEO.getSeoReport,
      data: actions.data,
      parseToJson: true,
    });
    if (response && response?.data?.status) {
      actions?.callback?.(response?.data?.status, response?.data?.seo_report_details);
      yield put(setPageLoaderVisibility(false));
    } else {
      actions?.callback?.(response?.data?.status, null);
      yield put(setPageLoaderVisibility(false));
    }
  } catch (err) {
    yield put(setPageLoaderVisibility(false));
    err?.data?.message && ToastNotifyError(err.data.message);
  }
}

function* getGscDetails(actions: any) {
  const storeId = getStoreId();
  try {
    yield put(setPageLoaderVisibility(true));
    const response = yield apiCall({
      method: "GET",
      url: `${SEO.getGscDetails}/${storeId}?start_date=${actions.data.start}&end_date=${actions.data.end}`,
    });
    if (response && response?.data?.status) {
      const parsedResponse = parseToJson(response.data.data);
      actions?.callback?.(response?.data?.status, parsedResponse);
      yield put(setPageLoaderVisibility(false));
    } else {
      actions?.callback?.(response?.data?.status, []);
      yield put(setPageLoaderVisibility(false));
    }
  } catch (err) {
    yield put(setPageLoaderVisibility(false));
    err?.data?.message && ToastNotifyError(err.data.message);
  }
}

export default function* root() {
  yield takeEvery(GET_SEO_QUICK_FIX_SCORE, getSEOQuickFixScore);
  yield takeEvery(GET_SEO_DETAIL_BY_TYPE, getSeoDetailsByType);
  yield takeEvery(UPDATE_SEO_DETAIL_BY_TYPE, updateSeoDetailsByType);
  yield takeEvery(GET_SEO_REPORT, getSeoReport);
  yield takeEvery(GET_GSC_DETAILS, getGscDetails);
}
